import {Injectable} from '@angular/core';
import {BmPaymentPlanService} from '../service/bm-payment-plan.service';
import {DunningData} from '../model/dunning-data.interface';
import {MOCK_DUNNING_DATA_1} from './mock-dunning-data-1';
import {MOCK_DUNNING_DATA_2} from './mock-dunning-data-2';
import {MOCK_DUNNING_DATA_3} from './mock-dunning-data-3';
import {MOCK_DUNNING_DATA_4} from "./mock-dunning-data-4";

@Injectable({
  providedIn: 'root'
})
export class BmPaymentPlanMockService extends BmPaymentPlanService {

  private mockDataSets: Map<number, DunningData> = new Map([
    [30001, MOCK_DUNNING_DATA_1],
    [30002, MOCK_DUNNING_DATA_2],
    [30003, MOCK_DUNNING_DATA_3],
    [30004, MOCK_DUNNING_DATA_4]
  ]);

  /**
   * Override loadDunningData to return mock data based on dunningId
   */
  override async loadDunningData(dunningId: number): Promise<DunningData> {
    return new Promise((resolve, reject) => {
      // Simulate API delay
      setTimeout(() => {
        const mockData = this.mockDataSets.get(dunningId);

        if (mockData) {
          resolve(mockData);
        } else {
          // If dunningId not found, return the first mock data set
          console.warn(`No mock data found for dunningId ${dunningId}, returning default data`);
          resolve(MOCK_DUNNING_DATA_4);
        }
      }, 500);
    });
  }

  /**
   * Get available mock dunning IDs for testing
   */
  getAvailableMockDunningIds(): number[] {
    return Array.from(this.mockDataSets.keys());
  }
}
